import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
	EMPTY_CRITERIA,
	PeopleSearchCategory,
	cloneCriteria,
	isCategoryActive,
} from "@/types/peopleSearch";
import { usePeopleSearch } from "@/contexts/PeopleSearchContext";
import { RolePanel } from "./panels/RolePanel";
import { CompanyPanel } from "./panels/CompanyPanel";
import { LocationPanel } from "./panels/LocationPanel";
import { KeywordsPanel } from "./panels/KeywordsPanel";
import { SkillsPanel } from "./panels/SkillsPanel";
import { LanguagesPanel } from "./panels/LanguagesPanel";
import { StatusPanel } from "./panels/StatusPanel";
import { ListsPanel } from "./panels/ListsPanel";
import { ProfileInfoPanel } from "./panels/ProfileInfoPanel";

export function renderCategoryPanel(category: PeopleSearchCategory) {
	switch (category) {
		case 'role': return <RolePanel />;
		case 'company': return <CompanyPanel />;
		case 'location': return <LocationPanel />;
		case 'keywords': return <KeywordsPanel />;
		case 'skills': return <SkillsPanel />;
		case 'languages': return <LanguagesPanel />;
		case 'status': return <StatusPanel />;
		case 'lists': return <ListsPanel />;
		case 'profile': return <ProfileInfoPanel />;
	}
}

export function CategoryPanel() {
	const { t } = useTranslation();
	const { draft, activeCategory, updateDraft } = usePeopleSearch();

	const clearDraftCategory = () =>
		updateDraft(activeCategory, cloneCriteria(EMPTY_CRITERIA)[activeCategory]);

	return (
		<div className="flex flex-col h-full min-h-0">
			<div className="flex items-center justify-between mb-4 shrink-0">
				<h3 className="text-base font-semibold">
					{t(`peopleSearch.categories.${activeCategory}`, activeCategory)}
				</h3>
				{isCategoryActive(draft, activeCategory) && (
					<Button
						variant="ghost"
						size="sm"
						onClick={clearDraftCategory}
						className="h-7 px-2 text-muted-foreground"
					>
						<X className="h-3.5 w-3.5 mr-1" />
						{t("peopleSearch.panel.clear", "Clear")}
					</Button>
				)}
			</div>
			<div className="flex-1 min-h-0 overflow-y-auto">
				{renderCategoryPanel(activeCategory)}
			</div>
		</div>
	);
}
